module.exports = __webpack_public_path__ + "img/specif_srb.7a83cf9a.jpg";